import React from "react"
import { Trans, useTranslation } from "react-i18next"
import { Flex } from "antd"
import { Icon } from "ui/Icon"
import useCartHold from "./useCartHold"
import formatCountdown from "./formatCountdown"
import styles from "./CartHold.module.css"

// "🕒 Your items are reserved for 09:59" beside the page title while the cart has items, and "Your
// places are no longer held" once the time is up. Renders nothing when there is no hold, or while
// a payment runs.
const CartHoldTimer = () => {
  const { t } = useTranslation()
  const { isActive, isExpired, remainingMs } = useCartHold()
  if (!isActive) return null
  return (
    <Flex align="center" justify="center" gap={6} className={`${styles.timer} ${isExpired ? styles.timerExpired : ""}`} role="timer" aria-live="off">
      <Icon type="feather" name="Clock" width={16} height={16} color="currentColor" />
      {isExpired ? (
        <span>{t("booking_widget.hold.expired")}</span>
      ) : (
        <span>
          <Trans i18nKey="booking_widget.hold.reserved_for" values={{ time: formatCountdown(remainingMs, { isMinutesPadded: true }) }} components={{ b: <strong /> }} />
        </span>
      )}
    </Flex>
  )
}

export default CartHoldTimer
